module.exports = __webpack_public_path__ + "static/media/company.bee3d39f.jpg";